import React, { ReactNode } from 'react'
import styles from './datePickerWtn.module.scss'
import cx from 'classnames'
import { ReactComponent as ArrowLeft } from 'images/icons/icn_calendar_arrow_left.svg'
import { ReactComponent as ArrowRight } from 'images/icons/icn_calendar_arrow_right.svg'

interface NavBtnConfig {
  disabled: boolean
  onClick: () => void
}

interface Props {
  className?: string
  config: {
    prev: NavBtnConfig
    next: NavBtnConfig
    fastPrev?: NavBtnConfig
    fastNext?: NavBtnConfig
  }
  children: ReactNode
}

const CustomHeaderNavigation = ({ children, config, className }: Props) => {
  const { next, prev, fastNext, fastPrev } = config

  return (
    <div className={cx(styles.headerContainer, className)}>
      <div className={styles.arrowsContainer}>
        {fastPrev && (
          <button
            className={cx(styles.arrow, styles.arrowPrev, styles.arrowFastPrev, {
              [styles.arrowDisabled]: fastPrev.disabled,
            })}
            onClick={fastPrev.onClick}
            disabled={fastPrev.disabled}
          >
            <ArrowLeft aria-hidden />
            <ArrowLeft aria-hidden />
          </button>
        )}

        <button
          className={cx(styles.arrow, styles.arrowPrev, {
            [styles.arrowDisabled]: prev.disabled,
          })}
          onClick={prev.onClick}
          disabled={prev.disabled}
        >
          <ArrowLeft aria-hidden />
        </button>
      </div>

      {children}

      <div className={styles.arrowsContainer}>
        <button
          className={cx(styles.arrow, styles.arrowNext, {
            [styles.arrowDisabled]: next.disabled,
          })}
          onClick={next.onClick}
          disabled={next.disabled}
        >
          <ArrowRight aria-hidden />
        </button>
        {fastNext && (
          <button
            className={cx(styles.arrow, styles.arrowNext, styles.arrowFastNext, {
              [styles.arrowDisabled]: fastNext.disabled,
            })}
            onClick={fastNext.onClick}
            disabled={fastNext.disabled}
          >
            <ArrowRight aria-hidden />
            <ArrowRight aria-hidden />
          </button>
        )}
      </div>
    </div>
  )
}

export default CustomHeaderNavigation
